import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { TransactionFilterKey } from 'api/Transaction/Types/Transaction'
import { TransactionType } from 'api/Wallet/Types/TransactionTypeDto'
import { FilterType } from 'components/Filter'
import { getIBCommissionsFilters } from 'components/Filter/getIBCommissionsFilters'
import { initialState } from 'store/grid'
import { links } from 'utils/featureToggles'
import { FilterLogic } from 'utils/QueryHelpers'

import { transactionIBCommissionsColumns } from './transactionIBCommissionsColumns'
import TransactionIBTransactionsOverview from './TransactionIBTransactionsOverview'

const TransactionIBCashBacksOverview = (): JSX.Element => {
  return (
    <>
      <Breadcrumbs
        crumbs={[
          { title: 'Transactions - IB Commissions', link: links.transactionIBCommissions.url },
        ]}
      />
      <TransactionIBTransactionsOverview
        filterType={FilterType.IB_COMMISSIONS}
        columns={transactionIBCommissionsColumns}
        filterFields={getIBCommissionsFilters}
        query={createTransactionIBCommissionsQuery()}
      />
    </>
  )
}

const createTransactionIBCommissionsQuery = () => {
  const initialGridState = initialState()

  return {
    ...initialGridState.filter,
    logic: initialGridState.filter.logic,
    defaultFilters: {
      logic: FilterLogic.OR,
      filters: [
        {
          field: TransactionFilterKey.type,
          operator: '==',
          value: TransactionType.IBCommission,
        },
        {
          field: TransactionFilterKey.type,
          operator: '==',
          value: TransactionType.MIBCommission,
        },
        {
          field: TransactionFilterKey.type,
          operator: '==',
          value: TransactionType.IBMultiTier,
        },
      ],
    },
  }
}

export default TransactionIBCashBacksOverview
